import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { inject, observer } from "mobx-react/index";
import { withApollo } from "react-apollo";
import { withI18n } from "@lingui/react";
import { t } from "@lingui/macro";
import { MenuDashBoard, ItemMenu, Icon } from "cf-neo-ui";
import SiderMenu from "./SiderMenu";
import SiderMenuItem from "./SiderMenuItem";
import Routes from "../../routes";
import configs from "../../../../configs/club-freelance-globals";

@inject(
  "sessionStore",
  "referenceTask",
  "postANeedStore",
  "candidatesSearchStore"
)
@observer
class SiderCompany extends Component {
  constructor(props) {
    super(props);
    this.myCompanyHandler = this.myCompanyHandler.bind(this);
    this.myInformationHandler = this.myInformationHandler.bind(this);
  }

  logoutClickHandler = () => {
    const {
      sessionStore,
      history,
      postANeedStore,
      candidatesSearchStore,
      client
    } = this.props;
    const { Home } = Routes.HbfLayoutRoutes;
    postANeedStore.reset();
    sessionStore.logout();
    candidatesSearchStore.clearSearch();
    client.cache.reset();
    history.push(Home.path);
  };

  myCompanyHandler = () => {
    const { MyCompany } = Routes.LpbLayoutRoutes;
    const { history, referenceTask } = this.props;
    const { setSideMenu } = referenceTask;
    setSideMenu();
    history.push(MyCompany.path);
  };

  myInformationHandler = () => {
    const { MyInformationCompany } = Routes.LpbLayoutRoutes;
    const { history, referenceTask } = this.props;
    const { setSideMenu } = referenceTask;
    setSideMenu();
    history.push(MyInformationCompany.path);
  };

  render() {
    const { history, location, sessionStore, i18n, referenceTask } = this.props;
    const { pictureUrl, profilePhoto } = sessionStore;
    const { LpbLayoutRoutes, HbfLayoutRoutes } = Routes;
    const { isSideMenuOpen, setSideMenu } = referenceTask;

    return (
      <aside className={`lpb-layout-sider ${isSideMenuOpen ? "active" : ""}`}>
        <div className="sider-logo">
          <Link to={HbfLayoutRoutes.client.path}>
            <picture>
              <source
                type="image/webp"
                srcSet="/assets/images/Logo_club_freelance.webp"
              />
              <img
                src="/assets/images/Logo_club_freelance.png"
                alt="mindquest"
              />
            </picture>
          </Link>
          {/*<p className="between_logos">&</p>*/}
          {/*<a*/}
          {/*  rel="noopener noreferrer"*/}
          {/*  href={configs.cf_website}*/}
          {/*  target="_blank"*/}
          {/*>*/}
          {/*  <picture>*/}
          {/*    <source*/}
          {/*      type="image/webp"*/}
          {/*      srcSet="/assets/images/Logo_club_freelance.webp"*/}
          {/*    />*/}
          {/*    <img*/}
          {/*      src="/assets/images/Logo_club_freelance.png"*/}
          {/*      alt="club-freelance"*/}
          {/*    />*/}
          {/*  </picture>*/}
          {/*</a>*/}
        </div>
        <div className="sider-close">
          <Icon type="close" width={12} height={11} onClick={setSideMenu} />
        </div>
        <SiderMenu>
          <SiderMenuItem
            active={location.pathname === LpbLayoutRoutes.DashboardCompany.path}
            iconType="speed-meter"
            title={i18n._(t`Dashboard`)}
            onClick={() => {
              history.push(LpbLayoutRoutes.DashboardCompany.path);
              setSideMenu();
            }}
          />
          <SiderMenuItem
            active={location.pathname === LpbLayoutRoutes.Offers.path}
            iconType="flag"
            title={i18n._(t`Offres`)}
            onClick={() => {
              history.push(LpbLayoutRoutes.Offers.path);
              setSideMenu();
            }}
          />
          <SiderMenuItem
            active={location.pathname === LpbLayoutRoutes.Talents.path}
            iconType="talent"
            title={i18n._(t`Talents`)}
            onClick={() => {
              history.push(LpbLayoutRoutes.Talents.path);
              setSideMenu();
            }}
          />
          {/* <SiderMenuItem
            active={location.pathname === LpbLayoutRoutes.CalendarCompany.path}
            iconType="calendar"
            title={i18n._(t`Calendrier`)}
            onClick={() => history.push(LpbLayoutRoutes.CalendarCompany.path)}
          /> */}
          <SiderMenuItem
            active={location.pathname.split("/")[2] === "timesheets"}
            iconType="clock"
            title={i18n._(t`Timesheets`)}
            onClick={() => {
              history.push(LpbLayoutRoutes.Timesheets.path);
              setSideMenu();
            }}
          />
          <SiderMenuItem
            active={location.pathname === LpbLayoutRoutes.Stats.path}
            iconType="statistiques"
            title={i18n._(t`Statistiques`)}
            onClick={() => {
              history.push(LpbLayoutRoutes.Stats.path);
              setSideMenu();
            }}
          />
          {/* <SiderMenuItem
            active={location.pathname === LpbLayoutRoutes.MarketData.path}
            iconType="data"
            title={i18n._(t`Données du marché`)}
            onClick={() => history.push(LpbLayoutRoutes.MarketData.path)}
          /> */}
        </SiderMenu>

        <div className="avatar-wrapper">
          <div className="avatar">
            <MenuDashBoard
              userName="User Name"
              percentage={100}
              image={pictureUrl || profilePhoto || "/defaultAvatar.png"}
            >
              <ItemMenu
                label={i18n._(t`Mes informations`)}
                value={1}
                onClick={this.myInformationHandler}
              />
              <ItemMenu
                label={i18n._(t`Mon entreprise`)}
                value={1}
                onClick={this.myCompanyHandler}
              />
              <ItemMenu
                label={i18n._(t`Se déconnecter`)}
                value={2}
                onClick={this.logoutClickHandler}
              />
            </MenuDashBoard>
          </div>
          <div className="user-name">
            {sessionStore.client.firstName} {sessionStore.client.lastName}
          </div>
        </div>
      </aside>
    );
  }
}

SiderCompany.wrappedComponent.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  postANeedStore: PropTypes.shape({
    reset: PropTypes.func
  }).isRequired,
  sessionStore: PropTypes.shape({
    logout: PropTypes.func,
    pictureUrl: PropTypes.string,
    profilePhoto: PropTypes.string,
    client: PropTypes.object
  }).isRequired,
  candidatesSearchStore: PropTypes.shape({
    clearSearch: PropTypes.func
  }).isRequired,
  i18n: PropTypes.shape({
    _: PropTypes.func
  }).isRequired,
  referenceTask: PropTypes.shape({
    isSideMenuOpen: PropTypes.bool,
    setSideMenu: PropTypes.func
  }).isRequired,
  client: PropTypes.shape({
    cache: PropTypes.object
  }).isRequired
};

export default withI18n()(withRouter(withApollo(SiderCompany)));
